import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import moment from 'moment';
import { withRouter } from 'react-router';

import { defaultDateFormat } from 'Common/GeneralHelper';
import { TitledCard } from 'Components/';
import { Filter, Main } from 'Containers/';
import { ParticipationReportForm } from './components/ParticipationReportForm';
import {
  ParticipationReportFieldEnum as Fields,
  ReportFieldEnum as ReportFields,
} from 'Common/FieldEnum';
import { PARTICIPATION_REPORT_FORM_NAME } from 'Common/FormEnum';
import { toastType, createToast } from 'Common/ToastHelper';
import { ReportGeneration } from 'Common/ObjectHelper';
import { LoadingPage } from 'Components/loading/LoadingPage';
import SelectSitesTable from 'Common/SelectSitesTable';
import { reportFormatEnum } from 'Common/Constants/Enumeration/ReportFormatEnum';

import { getReport, clearReport, downloadReport } from './state/report/actions';

class ParticipationReportContainer extends Component {
  state = {
    selectedSites: [],
  };

  componentDidUpdate(prevProps, prevState) {
    const { report, error } = this.props;
    if (error) {
      createToast(toastType.error, 'Error', 'Error retrieving report!', true);
    } else {
      if (prevProps.report !== report && report) {
        if (report === 'No Data') {
          createToast(toastType.info, 'Results', 'No data found!', true);
        } else {
          ReportGeneration(report, 'Participation Report');
        }
      }
    }
    this.props.clearReport();
  }

  handleSiteChange = values => {
    this.setState({
      selectedSites: values,
    });
  };

  getMainProps = () => {
    const { loading } = this.props;
    return {
      toolbox: {
        formName: PARTICIPATION_REPORT_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          loading: loading,
        },
        shown: true,
      },
    };
  };

  handleSubmit = formValues => {
    const { selectedSites } = this.state;
    const { [ReportFields.ReportFormat]: exportType, ...values } = formValues;
    const data = { exportType, ...values, SelectedSites: selectedSites };

    if (selectedSites && selectedSites.length === 0) {
      return createToast(
        toastType.error,
        'Error',
        'Please select one or more sites to continue!',
        true
      );
    }

    exportType !== reportFormatEnum.PDF
      ? this.props.downloadReport(data, `ParticipationReport`)
      : this.props.getReport(data);
  };

  onGroupBySiteGroupChange = groupBySiteGroup => {
    const { change } = this.props;
    const showSiteAvg = !groupBySiteGroup;
    change(PARTICIPATION_REPORT_FORM_NAME, Fields.ShowSiteAvg, showSiteAvg);
  };

  render() {
    const { loading, loadingMessage } = this.props;
    return (
      <Fragment>
        {loading && (
          <LoadingPage message={loadingMessage ? loadingMessage : 'Loading'} />
        )}
        <Filter title={'Participation'} />
        <Main {...this.getMainProps()}>
          <ParticipationReportForm
            onSubmit={this.handleSubmit}
            initialValues={{
              [Fields.ReportType]: 0,
              [Fields.FeedingType]: 0,
              [Fields.FromDate]: defaultDateFormat(moment()),
              [Fields.ToDate]: defaultDateFormat(moment()),
              [ReportFields.ReportFormat]: reportFormatEnum.PDF,
              [Fields.ShowSiteAvg]: true,
            }}
          />
          <TitledCard title={'Sites'}>
            <SelectSitesTable
              onGroupBySiteGroupChange={this.onGroupBySiteGroupChange}
              onChange={this.handleSiteChange}
            />
          </TitledCard>
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { report } = state.ParticipationReportState;

  return {
    report: report.report,
    sites: report.sites,
    selectedSites: report.selectedSites,
    loading: report.loading,
    loadingMessage: report.loadingMessage,
    error: report.error,
  };
};

const mapDispatchToProps = {
  getReport,
  clearReport,
  downloadReport,
  change,
};

export const Participation = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ParticipationReportContainer)
);



// WEBPACK FOOTER //
// ./src/pages/participation/Participation.js